import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class RowActionsService {
  constructor(private http: HttpClient) {}

  createDraw(lottoId: number) {
    return this.http.post('/lottodraw', { lottoId });
  }
}
